import { render, staticRenderFns } from "./cavu-calendar-days.vue?vue&type=template&id=25c5bfae&scoped=true"
import script from "./cavu-calendar-days.vue?vue&type=script&setup=true&lang=ts"
export * from "./cavu-calendar-days.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./cavu-calendar-days.vue?vue&type=style&index=0&id=25c5bfae&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c5bfae",
  null
  
)

export default component.exports